import script from "./AppManageTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./AppManageTeam.vue?vue&type=script&setup=true&lang=js"

import "./AppManageTeam.vue?vue&type=style&index=0&id=1c41ef6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c41ef6f"]])

export default __exports__